module.exports = __webpack_public_path__ + "img/24.e5719329.jpg";